import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import Navbar from '../../../Components/Navbar'
import Container from 'react-bootstrap/Container'
import { Redirect } from 'react-router-dom'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import InsideMenu from '../../../Components/InsideMenu'
import { fetchUserInfo } from '../../../redux-flow/actions/users'
import SideBar from '../../../Components/SideBar'
import walletImg from '../../../images/wallet.png'
import { Button, Icon } from 'antd'
import { submitLista } from '../../../redux-flow/actions/wallet'
import BoxToken from '../../../Components/BoxToken'

const LoadingComponent = () => (
    <div style={{ textAlign: 'center' }}>
        <Icon type="loading" />
    </div>
)

class ListaDeEspera extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            walletLogged: false,
            password: '',
            loading: false,
            step: 1
        }
    }  

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleWindowScroll, true)
    }

    componentDidMount() {
        const { onLoad, userid } = this.props
        if(onLoad && userid) {
            onLoad(userid)
        }
    }

    componentDidUpdate() {
        
    }


        
    render() {
            const { logged, userLogged, message, success, isLoading, handleSubmit, userid  } = this.props
            return (   
                <>
                    <Navbar loggedArea={true}/>
                    {!logged ? <Redirect to="/login" /> : userLogged.permissao === 3 ? <Redirect to="/wallet" /> : (
                        <div>
                            <div className="section minhaContaWrapper">
                                <Container>
                                    <Row>
                                        <Col md={12} className="p-0">
                                            <InsideMenu />
                                        </Col>
                                    </Row>
                                </Container>
                            </div>
                        
                            <div className="section insideSec">
                                <Container>
                                    <Row>
                                        <Col md={2} className="p-0" style={{borderRight: '1px solid #F6F3FF'}}>
                                            <SideBar permissao={userLogged.permissao} nivelVerificacao={userLogged.nivelVerificacao} />
                                        </Col>
                                        <Col md={10}>
                                            {!success && message != '' &&
                                                <center><div class="alert alert-danger fade show" role="alert" style={{width: 'max-content'}}>
                                                    <p className="mb-0">{message}</p>
                                                </div></center>
                                            }
                                            {success && message != '' &&
                                                <center><div class="alert alert-success fade show" role="alert" style={{width: 'max-content'}}>
                                                    <p className="mb-0">{message}</p>
                                                </div></center>
                                            }
                                            <center><img src={walletImg} className="img-fluid m-auto"/></center>
                                            {userLogged.contagemBeta === null || userLogged.contagemBeta === undefined ?
                                                <>
                                                <h4 className="tx-pink font-weight-bold mt-3">Nosso produto está em beta fechado.</h4>
                                                <center><h4 className="tx-pink font-weight-bold mt-3">Junte-se a nossa lista de espera!<br />Em breve liberaremos novas vagas.</h4></center>
                                                {isLoading ? <LoadingComponent /> :
                                                    <center><Button onClick={() => handleSubmit(userid)} className="mt-3 mb-5 text-center btnGrafico w-50">Cadastrar</Button></center> 
                                                }
                                                </>
                                                :
                                                <h4 className="tx-pink font-weight-bold mt-3 mb-5">Você já está cadastrado em nossa lista de espera.<br />Em breve liberaremos novas vagas.</h4>
                                            }
                                            <BoxToken />
                                        </Col>
                                    </Row>
                                </Container> 
                            </div>
                        </div>   
                    )}


                </>
            )
        }
    }

const mapStateToProps = state => ({
    logged: state.login.logged,
    userid: state.login.userid,
    userLoading: state.users.isLoading,
    userLogged: state.users.userLogged,
    isLoading: state.wallet.isLoading,
    success: state.wallet.success,
    message: state.wallet.message,
})

const mapDispatchToProps = dispatch => ({
    onLoad: (id) => {
        dispatch(fetchUserInfo(id))
    },
    handleSubmit: userid => {
        dispatch(submitLista(userid))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(ListaDeEspera)
